<style lang="scss" scoped>
@import '@/styles/variables.scss';
.navbar {
	.logo {
		height: 35px;
		width: auto;
	}
	.nav-link {
		letter-spacing: 0.5px;
		font-weight: $font-weight-semi-bold;
	}
	.counter {
		font-size: 10px;
		color: #fff;
		background: $primary;
		border-radius: 50%;
		width: 15px;
		height: 15px;
		line-height: 15px;
		display: inline-block;
        text-align: center;
        margin: auto 0 auto 7.5px;
	}
	.nav-menu {
		display: flex;
		margin-left: 30px;
		padding-left: 30px;
		border-left: 1px solid #e3eaee;
	}
}
</style>

<template>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white border-bottom">

        <router-link class="navbar-brand" :to="{ name: 'search' }">
            <i-logo class="logo"></i-logo>
        </router-link>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#vengoNavbar" aria-controls="vengoNavbar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="vengoNavbar">

            <ul class="navbar-nav ml-auto text-uppercase">
                <li class="nav-item mr-30">
                    <router-link class="nav-link d-flex" active-class="active" :to="{ name: 'search' }">{{ $t('layout.search') }} <span v-if="newshipmentscount > 0" class="counter">{{ newshipmentscount }}</span></router-link>
                </li>
                <li class="nav-item mr-30">
                    <router-link class="nav-link d-flex" active-class="active" :to="{ name: 'offers' }">{{ $t('layout.offers') }} <span v-if="openofferscount > 0" class="counter">{{ openofferscount }}</span></router-link>
                </li>
                <li class="nav-item mr-30">
                    <router-link class="nav-link d-flex" active-class="active" :to="{ name: 'shipments' }">{{ $t('layout.myshipments') }} <span v-if="activeshipmentscount > 0" class="counter">{{ activeshipmentscount }}</span></router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link d-flex" active-class="active" :to="{ name: 'fleet' }">{{ $t('layout.fleet') }} <span v-if="activefleetdriverscount > 0" class="counter">{{ activefleetdriverscount }}</span></router-link>
                </li>
            </ul>

            <ul class="navbar-nav ml-auto" v-if="user">
                <li class="nav-item mr-15 position-relative d-flex">
                    <a class="nav-link my-auto" href="#" @click="showNotifications = true">
                        <i-bell class="p-0"></i-bell>
                    </a>

                    <notifications :show="showNotifications" @close="showNotifications = false"></notifications>
                </li>
                <li class="nav-item d-flex">
                    <router-link class="nav-link my-auto" active-class="active" :to="{ name: 'chat' }">
                        <i-chat class="p-0"></i-chat>
                    </router-link>
                </li>
                <li v-if="user" class="nav-item nav-menu">
                    <router-link class="nav-link text-secondary mb-0" active-class="active" :to="{ name: 'profile-settings' }">
                        <profile-image :size="29" class="mr-15" :user="user"></profile-image>
                        {{ user.first_name }} {{ user.last_name }}
                    </router-link>
                </li>
            </ul>

        </div>
    </nav>
</template>


<script>
import { mapGetters } from 'vuex'
import Notifications from '@/components/global/notifications'
export default {
	components: { Notifications },
	data() {
		return {
            showNotifications: false         
		}
	},
	computed: mapGetters(['user', 'newshipmentscount', 'openofferscount', 'activeshipmentscount', 'activefleetdriverscount'])
}
</script>
